/* eslint-disable @typescript-eslint/no-unused-vars */

// 某特定寵物，有 _ 可使用方案
export const is_Pet_Has_Plans = ( pet_Plans : any[] ) : boolean => pet_Plans?.length > 0 ;



